"use client";

import { create } from "zustand";

import { AUTH_METHODS, type AuthMethod } from "@/lib/constants/auth-methods";

const STORAGE_KEY = "nimble_last_auth_method";

export interface LastAuthMethodStore {
  lastAuthMethod: AuthMethod | null;
  setLastAuthMethod: (method: AuthMethod) => void;
}

export const getInitialAuthMethod = (): AuthMethod | null => {
  if (typeof localStorage === "undefined") return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    if (!Object.values(AUTH_METHODS).some((m) => m === stored)) return null;
    return stored as AuthMethod;
  } catch {
    return null;
  }
};

const useLastAuthMethod = create<LastAuthMethodStore>()((set) => ({
  lastAuthMethod: getInitialAuthMethod(),
  setLastAuthMethod: (method: AuthMethod) => set({ lastAuthMethod: method }),
}));

useLastAuthMethod.subscribe((state) => {
  if (typeof localStorage === "undefined") return;
  if (state.lastAuthMethod) {
    localStorage.setItem(STORAGE_KEY, state.lastAuthMethod);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
});

export default useLastAuthMethod;
